var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { attrs: { id: "tlyPageGuide", "data-tourtitle": "Searching the corpus" } },
    [
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": "a[href='#simple']" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.simple")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": "a[href='#extended']" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.extended")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_bottom",
          attrs: { "data-tourtarget": "#extended_split_batch" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.split")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_left",
          attrs: { "data-tourtarget": ".propertyfield .file-input-button" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.upload")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": "a[href='#advanced']" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.querybuilder")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".bl-token .panel-heading" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.token")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".bl-token-create" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.tokenButton")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_right",
          attrs: { "data-tourtarget": ".bl-token-attribute" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.attribute")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": "a[href='#expert']" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.CQLeditor")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_bottom",
          attrs: { "data-tourtarget": "#gapFilling" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.TSVbutton")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_bottom",
          attrs: { "data-tourtarget": "#importQuery" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.importQuery")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": "#filterContainer" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.metedata")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": "#resultTabs" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.results")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".results-table th .dropdown" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.sortHits")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".doctitle a" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.showHit")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".results-table tr.concordance" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.clickHit")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".groupselect" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.resultsGrouped")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".group-size-indicator" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.clickGroup")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_top",
          attrs: { "data-tourtarget": ".open-concordances" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.clickGoBack")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "tlypageguide_right",
          attrs: { "data-tourtarget": "tr.document" },
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pageGuide.documentInfo")) },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }